import * as React from "react"
import Parser from 'html-react-parser'
import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import "react-quill/dist/quill.snow.css"
import terms from './termsOfITG.json';

function ITGTermPage() {
  const [content, setContent] = React.useState("")
  const [language, setLanguage] = React.useState("JP")

  const contentJa = terms.termsJa.contentJa ?? ""
  const contentEn = terms.termsEn.contentEn ?? ""

  const changeLanguage = () => {
    switch (language) {
      case "JP":
        setContent(contentJa || '')
        break
      case "EN":
        setContent(contentEn || '')
        break
    }
  }

  React.useEffect(() => {
    changeLanguage()
  }, [language])

  return (
    <Box
      sx={{
        margin: '0 auto',
        maxWidth: '800px',
        height: '100%',
        boxSizing: 'border-box',
        padding: '20px',
        whiteSpace: 'wrap',
        wordBreak: 'break-word',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Stack direction="row" gap={2}>
        <Button
          type="button"
          color="primary"
          variant="contained"
          onClick={() => setLanguage("JP")}
        >
          {"日本語"}
        </Button>
        <Button
          type="button"
          color="primary"
          variant="contained"
          onClick={() => setLanguage("EN")}
        >
          {"English"}
        </Button>
      </Stack>
      <Box
        className="ql-editor"
        sx={{
          margin: '20px 0',
          overflowY: 'auto',
        }}
      >
        {Parser(String(content))}
      </Box>
    </Box>
  )
}

export default ITGTermPage
